import { FC } from 'react'

import { useSelectedOptionsCount, useFiltersInfo } from './hooks'
import { FilterDropDown, FilterSelectionList } from '.'
import { MFilters } from 'types/filterTypes'
import { Badge } from 'ui'

type HeroFilterProps = {
  name: string
  contentName: MFilters.ContentTypes
}

const HeroFilter: FC<HeroFilterProps> = ({ name, contentName }) => {
  const filterTypes = useFiltersInfo(contentName, name)
  const { icon, label, type } = filterTypes[0] || {}
  const count = useSelectedOptionsCount({ contentName, heroFilter: type })

  if (!filterTypes.length) return null

  return (
    <FilterDropDown
      buttonContent={
        <div className="d-flex flex-row justify-content-between align-items-baseline ">
          <div className="d-flex flex-row align-items-baseline">
            <i className={`fa ${icon} ${count ? ' text-primary' : ''} mr-1 `} />
            {label}
          </div>
          <div className="d-flex flex-row align-items-baseline">
            {count ? (
              <Badge variant="primary" className="ml-2">
                {count}
              </Badge>
            ) : null}
            <i className={`fa fa-caret-down ml-2`} />
          </div>
        </div>
      }
      splitButton="clearButton"
      type={type}
      contentName={contentName}
      count={count}
      name={name}
      dropDownType="HeroFilter"
    >
      {({ isOpen }) => (
        <div className="" style={{ width: '310px' }}>
          <FilterSelectionList filter={filterTypes[0]} contentName={contentName} isOpen={isOpen} />
        </div>
      )}
    </FilterDropDown>
  )
}

export default HeroFilter
